import useSWR from "swr";


export const useFetchTotalStaffSurveyResponse = (restaurantId?: string, queryParams?: URLSearchParams) => {
  const fetchKey = restaurantId
    ? `restaurant_staff/restaurants/${restaurantId}/survey/responses/total/${queryParams?.toString() && `?${queryParams}`}`
    : null;
  const { data: totalStaffSurveyResponse, error, isLoading } = useSWR<number>(fetchKey)
  return { totalStaffSurveyResponse, isLoading, error };
};